import i18n from 'i18next';
import Backend from 'i18next-http-backend';

import translationEN from '../src/assets/translations/en.json';
import translationNL from '../src/assets/translations/nl.json';

export const resources: any = {
  en: {
    code: 'en-US',
    translation: translationEN,
  },
  nl: {
    code: 'nl-NL',
    translation: translationNL,
  },
};

const browserLanguage: string = navigator?.language?.split('-')[0];
let lng: string = Object.prototype.hasOwnProperty.call(resources, browserLanguage) ? browserLanguage : 'en';
const preferredLanguage = localStorage.getItem('preferredLanguage');
if (preferredLanguage) {
  lng = JSON.parse(preferredLanguage);
}

const backofficei18nInstance = i18n.createInstance();
backofficei18nInstance
  .use(Backend)
  .init({
    resources,
    lng,
    debug: true,
    interpolation: {
      escapeValue: false,
    },
  });

export default backofficei18nInstance;
